import { Button, Group, Box, Text } from '@mantine/core';
import moment from 'moment';

import { Batch, EORIGIN_DATE_FORMAT_WITH_TIME } from '@e-origin/shared';

import classes from './FailedBatchDetails.module.css';

interface FailedBatchDetailsProps {
  onHide: () => void;
  batch?: Batch;
}

export const FailedBatchDetails: React.FC<FailedBatchDetailsProps> = (props) => {
  const errorText = props.batch?.status.details?.replace(/Error: /g, '');

  return (
    <>
      <Box className={classes.messageWrapper}>
        <Group className={classes.messageRow}>
          <Box>
            <Text className={classes.label}>Batch id</Text>
            <Text className={classes.paragraph}>{props.batch?.counter}</Text>
          </Box>
          <Box>
            <Text className={classes.label}>Batch name</Text>
            <Text className={classes.paragraph}>{props.batch?.name}</Text>
          </Box>
          <Box>
            <Text className={classes.label}>Date</Text>
            <Text className={classes.paragraph}>{props.batch?.updatedAt && moment(props.batch?.updatedAt).format(EORIGIN_DATE_FORMAT_WITH_TIME)}</Text>
          </Box>
        </Group>
        <Box className={classes.messageRow}>
          <Box>
            <Text className={classes.label}>Error details</Text>
            <Text className={`${classes.paragraph} ${classes.errorText}`}>{errorText}</Text>
          </Box>
        </Box>
      </Box>
      <Group justify="center">
        <Button type="button" key="cancel-modal-btn" onClick={props.onHide} variant="outline" size="lg">
          Close
        </Button>
      </Group>
    </>
  );
};
